import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { smallScreens, lowHeightScreens } from 'components/common/fontElements';

export const Wrapper = styled.div`
  padding: 2px 0px 5px 23px;
  background-color: ${colors.lightGray14};
  border-top: 10px solid white;
  display: flex;
  align-items: center;
  border-top: 0px;
  height: 28px;
  border-bottom: 1px solid ${colors.lightGray6};
`;

export const SelectionPath = styled.div`
  list-style: none;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  font: 9px Sans-Serif;
`;

export const HouseIcon = styled.img`
  height: 12px;
  width: 12px;
  margin-top: 5px;
  align-self: flex-start;

  &:hover {
    cursor: pointer;
  }
`;

export const SelectionPathSection = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.isLink ? 'pointer' : 'auto')};

  img {
    position: relative;
    top: 1px;
    animation-name: fadeIn;
    animation-duration: 0.5s;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  span {
    color: ${(props) => (props.isLink ? colors.darkGray1 : colors.lightBlack)};
    font-size: 10px;
    font-weight: ${(props) => (props.isLink ? '300' : '500')};
    text-decoration: none;
    padding: 5px 15px 4px 15px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
    text-align: left;
    animation-name: fadeIn;
    animation-duration: 0.5s;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
      font-size: 8px;
      padding: 4px 12px 3px 12px;
    }
  }
`;
